angular.module('pe4h').run(['$templateCache', function($templateCache) {
  $templateCache.put('shared/components/footer/footer.html',
    '<footer id="footer" ng-controller="FooterController"  ng-show="visibleHeaderFooter()">\n' +
    '    <div class="container-fluid">\n' +
    '        <div class="row">\n' +
    '            <div class="col-xs-6 col-sm-9">\n' +
    '                <div class="row nav-footer">\n' +
    '                    <div class="col-xs-12 col-sm-2">\n' +
    '                        <a href="" ui-sref="index" class="logo">\n' +
    '                            <svg class="symbol" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 61.2 70.7">\n' +
    '                                <polygon class="pol-a white" points="44.4 43.3 44.4 43.3 30.6 51.3 16.8 43.3 16.8 43.3 0 53 30.6 70.7 61.2 53"/>\n' +
    '                                <polygon class="pol-b white" points="30.6 0 30.6 19.4 44.4 27.4 44.4 43.3 61.2 53 61.2 17.7"/>\n' +
    '                                <polygon class="pol-c white" points="16.8 27.4 30.6 19.4 30.6 0 0 17.7 0 53 16.8 43.3"/>\n' +
    '                            </svg>\n' +
    '                        </a>\n' +
    '                    </div>\n' +
    '                    <div class="col-xs-12 col-sm-3 col-lg-2">\n' +
    '                        <h5>\n' +
    '                            <a href="" ui-sref="about">About</a>\n' +
    '                        </h5>\n' +
    '                        <ul class="nav nav-pills nav-stacked">\n' +
    '                            <li>\n' +
    '                                <a href="" ui-sref="about({\'#\':\'company\'})">Company</a>\n' +
    '                            </li>\n' +
    '                            <li>\n' +
    '                                <a href="" ui-sref="about({\'#\':\'contact\'})">Contact</a>\n' +
    '                            </li>\n' +
    '                        </ul>\n' +
    '                    </div>\n' +
    '                    <div class="col-xs-12 col-sm-3 col-lg-2">\n' +
    '                        <h5>\n' +
    '                            <a href="" ui-sref="resources">Resources</a>\n' +
    '                        </h5>\n' +
    '                        <ul class="nav nav-pills nav-stacked">\n' +
    '                            <li>\n' +
    '                                <a href="" ui-sref="resources({\'section\':\'how-it-works\'})">How it Works</a>\n' +
    '                            </li>\n' +
    '                            <li>\n' +
    '                                <a href="" ui-sref="resources({\'section\':\'faq\'})">FAQ</a>\n' +
    '                            </li>\n' +
    '                            <li>\n' +
    '                                <a target="_blank" rel="noopener" href="https://www.peforhire.com/blog/">Engineering Insights</a>\n' +
    '                            </li>\n' +
    '                        </ul>\n' +
    '                    </div>\n' +
    '                    <div class="col-xs-12 col-sm-4 col-lg-3">\n' +
    '                        <h5>\n' +
    '                            <a href="" ui-sref="legal">Legal</a>\n' +
    '                        </h5>\n' +
    '                        <ul class="nav nav-pills nav-stacked">\n' +
    '                            <li>\n' +
    '                                <a href="" ui-sref="legal">Privacy Policy</a>\n' +
    '                            </li>\n' +
    '                            <li>\n' +
    '                                <a href="" ui-sref="terms">Terms and Conditions</a>\n' +
    '                            </li>\n' +
    '                        </ul>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '            <div class="col-xs-6 col-sm-3">\n' +
    '                <div class="share-icons">\n' +
    '                    <a href="https://www.facebook.com/PEForHire/" target="_blank" class="fa fa-facebook-official"></a>\n' +
    '                    <a href="https://twitter.com/PEForHire" target="_blank" class="fa fa-twitter"></a>\n' +
    '                    <a href="https://www.linkedin.com/company/pe-for-hire" target="_blank" class="fa fa-linkedin"></a>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '            <div class="clearfix"></div>\n' +
    '            <div class="col-sm-12 mt40">\n' +
    '                <small class="copyright">{{year}}\n' +
    '                    P.E. For Hire, LLC. All Rights Reserved.</small>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</footer>\n' +
    '');
}]);
